import _extends from "@babel/runtime/helpers/extends";
import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EnumAgreementStatus, EnumInvoiceStatus } from 'api';
import InfoRow from 'components/InfoRow/InfoRow';
import StatusBullet from 'components/StatusBullet/StatusBullet';
import AddressTypes from 'constants/addressTypes';
import { NOT_AVAILABLE } from 'constants/text';
import getAgreementTranslateStatus from 'utils/agreements/getAgreementTranslateStatus';
import dateTimeFormatter from 'utils/date/dateTimeFormatter';
import getInvoiceTranslationString from 'utils/invoices/getInvoiceTranslationString';
import getObeStatusBullet from 'utils/obes/getObeStatusBullet';
import useStyles from '../AgreementStyles';
import AgreementAddressInfo from './AgreementAddressInfo';
export default function AgreementInfo({
  agreementNumber,
  createdOn,
  statusChangedOn,
  status,
  totalVehicles,
  shippingAddress,
  billingAddress,
  hasClosedInvoices
}) {
  const {
    t
  } = useTranslation();
  const {
    agreementInfoBox
  } = useStyles();
  const statusTranslation = status && t(getAgreementTranslateStatus(status));
  let statusText;
  if (hasClosedInvoices && status === EnumAgreementStatus.Frozen) statusText = `${statusTranslation} (${t(`invoice_status.${getInvoiceTranslationString(EnumInvoiceStatus.ClosedByDebtCollector)}`)})`;else statusText = statusTranslation;
  return /*#__PURE__*/React.createElement(Box, {
    className: agreementInfoBox
  }, /*#__PURE__*/React.createElement(InfoRow, {
    dense: true,
    primary: t('tag.agreement_number'),
    secondary: agreementNumber || NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(InfoRow, {
    dense: true,
    primary: t('agreements.total_tags'),
    secondary: totalVehicles
  }), /*#__PURE__*/React.createElement(InfoRow, {
    dense: true,
    primary: t('agreements.created_at'),
    secondary: createdOn ? dateTimeFormatter(createdOn) : NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(InfoRow, {
    dense: true,
    primary: t('agreements.last_changed'),
    secondary: statusChangedOn ? dateTimeFormatter(statusChangedOn) : NOT_AVAILABLE
  }), /*#__PURE__*/React.createElement(InfoRow, {
    dense: true,
    primary: t('agreements.agreement_status'),
    secondary: status && /*#__PURE__*/React.createElement(StatusBullet, {
      status: getObeStatusBullet[status],
      text: statusText
    })
  }), billingAddress && /*#__PURE__*/React.createElement(AgreementAddressInfo, _extends({
    addressType: AddressTypes.BILLING
  }, billingAddress)), shippingAddress && /*#__PURE__*/React.createElement(AgreementAddressInfo, _extends({
    addressType: AddressTypes.SHIPPING
  }, shippingAddress)));
}